
import React, { useState, useEffect } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { Trans } from 'react-i18next';
const useStyles = makeStyles(styles);

const GerenciaAlertEncerrar = () => { 

    const classes = useStyles();

    const [alert, setAlert] = useState({
        componente:(null),
        isToClose: false,
        idToCloseSend: 0
    });
    const [confAlert, setConfAlert] = useState({
        statusAlert:0,
        idToCloseRecieve:0
    });
    /*
    statusAlert
    1 - showalert
    2 - hideAlert
    3 - sucess 
    */

    useEffect(() => {

        //console.log(confAlert);

        if (confAlert.statusAlert === 1) {
            showAlertClose(confAlert.idToCloseRecieve);
        }
        else if (confAlert.statusAlert === 2) {
            hideAlertClose();
        }
        else if (confAlert.statusAlert === 3) {
            successClose();
        }

    }, [confAlert]);
  
    const confirmClose = (id) =>{
        setAlert(
            {
                componente:null,
                isToClose:true,
                idToCloseSend: id
            }
        );
      
    }

    const showAlertClose = (id) => {
             
        setAlert(
            {
                componente:(<SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.close_campaign">
                                Tem certeza que deseja encerrar essa campanha?
                            </Trans>}
                    onConfirm={() => confirmClose(id)}
                    onCancel={() => setConfAlert({statusAlert:2})}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    cancelBtnCssClass={classes.button + " " + classes.danger}
                    confirmBtnText={<Trans i18nKey="information_message.confirm_close_campaign"> Sim, encerrar essa campanha! </Trans>}
                    cancelBtnText={<Trans i18nKey="button.cancel"> Cancelar </Trans>}
                    showCancel 
                    >
                        {<Trans i18nKey="information_message.close_campaign">
                            Tem certeza que deseja encerrar essa campanha?
                        </Trans>}                     
                    </SweetAlert>),
                isToClose: false
            }
        );
    };

    const successClose = () => {

        setAlert(
            {
                componente:(<SweetAlert
                    success
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.campaign_close"> Campanha Encerrada! </Trans>}
                    onConfirm={() => setConfAlert({statusAlert:2})}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    >
                    {<Trans i18nKey="information_message.success_close_campaign">
                       Campanha encerrada com sucesso.
                    </Trans>}                      
                    </SweetAlert>),
                isToClose: false
            }
        );

    };
    
    const hideAlertClose = () => {
        setAlert(
            {
                componente:(null),
                isToClose: false,
                idToClose: 0
            }
        );
    };
  
    return [alert, setConfAlert];
  };
  
  export {GerenciaAlertEncerrar};